<script>
  import { onMount } from 'svelte';
  import { goto } from '$app/navigation';

  import { getProfileStore } from '@stores/profile';
  let appInvitesStore = getProfileStore('appInvitesStore');
  import AppInviteAjax from '@ajax/app_invite';
  import { getCurrentUserStore } from '@stores/current_user';
  import Notifications from '@app-components/Notifications.svelte';
  import { browser } from '$app/environment';
  import jQuery from 'jquery';

  export let currentPage;
  export let fetchInvites = true;

  let bottomBarEl;

  let currentUser = getCurrentUserStore('default');

  $: showInvites = currentUser && currentUser.email && !currentUser.email.includes('@demo.benable.com');

  $: showInviteCodeNudge = currentUser?.show_app_invite_nudge;

  $: options = [
    {
      id: 1,
      label: 'Discover',
      image: '/images/bottom-bar/discover@1x.png',
      imageSrcSet: '/images/bottom-bar/discover@1x.png 1x, /images/bottom-bar/discover@2x.png 2x',
      selectedImage: '/images/bottom-bar/discover-selected.svg',
      alt: 'discover',
      action: () => {
        goto('/discover');
      },
    },

    showInvites
      ? {
          id: 3,
          label: `<span style="position: relative">Invites
            ${
              showInviteCodeNudge ? '<div class="navigation-red-dot" style="top: -30px; right: 2px;"></div>' : ''
            }</span>`,
          image: '/images/bottom-bar/invites.svg',
          selectedImage: '/images/bottom-bar/invites-selected.svg',
          alt: 'app-invites',
          action: () => {
            goto('/app_invites');
          },
        }
      : undefined,
    {
      id: 4,
      label: 'notifications',
    },
    {
      id: 2,
      label: `<span style="position: relative">Profile
        ${
          currentUser.viewed_profile ? '' : '<div class="navigation-red-dot" style="top: -30px; right: 2px;"></div>'
        }</span>`,
      image: currentUser && currentUser.avatar_url,
      imageClass: 'avatar',
      alt: 'profile',
      action: () => {
        goto(currentUser.profile_path);
      },
    },
  ];

  let loadInvites = async function () {
    if (fetchInvites && currentUser && currentUser.id && appInvitesStore && appInvitesStore.length === 0) {
      try {
        let appInvites = await AppInviteAjax.fetch();
        appInvitesStore.set(appInvites);
      } catch {}
    }
  };

  let loadHeight;

  loadInvites();

  onMount(() => {
    let unsub = currentUser.subscribe((x) => (currentUser = x));

    if (currentUser && currentUser.id) {
      if (!loadHeight) {
        loadHeight = window.innerHeight;
      }

      jQuery('#svelte').addClass('bottom-bar-visible');
    }

    return () => {
      unsub();
      jQuery('#svelte').removeClass('bottom-bar-visible');
    };
  });
</script>

<style style="text/scss" lang="scss">
  .bottom-bar {
    position: fixed;
    bottom: 0px;
    left: 0px;
    right: 0px;
    height: 64px;
    background: white;
    z-index: 6;
    display: flex;
    box-shadow: 0px 22px 100px rgba(0, 0, 0, 0.0938593);
    padding-left: 20px;
    padding-right: 20px;

    &.bottom-bar-5-icons {
      padding-left: 10px;
      padding-right: 10px;
    }

    .bottom-bar-tab {
      flex: 1;
      display: flex;
      align-items: center;
      justify-content: center;
      flex-direction: column;

      img {
        width: 24px;
        height: 24px;

        &.avatar {
          border: 1px solid rgb(236, 236, 236);
          border-radius: 999px;
        }
      }

      .bottom-bar-tab-label {
        margin-top: 8px;
        font-weight: bold;
        font-size: 11px;
        line-height: 8px;
        text-transform: capitalize;
        color: #a19bb8;
      }

      .bottom-bar-tab-label-selected {
        color: #5e518e;
      }
    }
  }
</style>

{#if browser && currentUser && currentUser.id}
  <div bind:this={bottomBarEl} class="bottom-bar {options.length >= 5 ? 'bottom-bar-5-icons' : ''}">
    {#each options.filter((x) => x !== undefined) as option}
      {#if option.label === 'notifications'}
        <div
          class="bottom-bar-tab"
          style="padding-left: 10px;"
          on:click={() => goto(currentUser.profile_path + '/notifications')}>
          <Notifications mobile={true} openDropdown={() => {}} buttonActive={currentPage === option.label} />

          <div class="bottom-bar-tab-label" class:bottom-bar-tab-label-selected={currentPage === option.label}>
            Notifications
          </div>
        </div>
      {:else}
        <div class="bottom-bar-tab" on:click={option.action}>
          {#if currentPage === option.alt && option.selectedImage}
            <img
              srcset={option.selectedImageSrcSet}
              src={option.selectedImage}
              class={option.imageClass}
              alt={option.alt} />
          {:else}
            <img srcset={option.imageSrcSet} src={option.image} class={option.imageClass} alt={option.alt} />
          {/if}

          <div class="bottom-bar-tab-label" class:bottom-bar-tab-label-selected={currentPage === option.alt}>
            {@html option.label}
          </div>
        </div>
      {/if}
    {/each}
  </div>
{/if}
